import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Form,
    Input
} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import { Listino } from '../components/Listino/Listino';
import { Listino2 } from '../components/Listino/Listino2';
import { Listino3 } from '../components/Listino/Listino3';
import { Search } from '../components/Search';


/**
 * Used for the Listino Prezzi section. 
 */
class ListinoContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {

            test: 1,
            title: "LISTINO PRODOTTI",
            livelli1: [],
            livelli1Index: 0,
            livelli1Id: 0,
            livelli1Val: "",
            livelli1BGColor: "",
            showLivelli1: true,
            livelli2: [],
            livelli2Index : 0,
            livelli2Id: 0,
            livelli2Val: "Scegli il Livello 2",
            showLivelli2: false,
            livelli3HasItems: false,   
            livelli3: [],
            livelli3Index : 0,
            livelli3Id: 0,
            livelli3Val: "",
            showLivelli3: false,
            livelli4TotalArticoli: 0,
            livelli4TotalPages: 0,
            livelli4: [],
            showLivelli4: false,
            numPerPage: 5,
            changeNumPerPage: 0,
            pageNum: 1,   
            searchText: "",             
        };
    
    }

    componentDidMount() {
        if(!this.props.isChild){
            this.unlisten = this.props.history.listen((location, action) => {
                console.log(this.props.history.location.state);
                console.log(this.state)
    
                
                
                if(this.state.showLivelli1 && this.state.showLivelli2){
                    if(this.state.livelli3HasItems){
                        
                        if(action === "PUSH"){
                            this.setState({
                                showLivelli1: false,
                                showLivelli2: false,
                                showLivelli3: true,
                                livelli3Id: 0,
                                numPerPage: 5,
                            });
                        }
                        else{
                            this.setState({
                                ...this.props.history.location.state,
                                showLivelli1: false,
                                showLivelli2: false,
                                showLivelli3: true,
                                livelli1Id: this.state.livelli1Id,
                                livelli2Id: this.state.livelli2Id,
                                livelli3Id: this.state.livelli3Id,
                                numPerPage: this.state.numPerPage,
                                pageNum: this.state.pageNum,
                                searchText: this.state.searchText,
                                livelli4: this.state.livelli4
                            });
                        }
                        
                    }
                    else{
                        if(action === "PUSH"){
    
                            this.setState({
                                showLivelli1: false,
                                showLivelli2: false,
                                showLivelli4: true,
                                livelli3Id: 0,
                                numPerPage: 5,
                            });
                        }
                        else{
                            this.setState({
                                showLivelli1: false,
                                showLivelli2: false,
                                showLivelli4: true,
                                searchText: this.state.searchText,
                                livelli4: this.state.livelli4,
                            });
                        }
                        
                    }
                    
                }
                else if(this.state.showLivelli3){
                    if(this.props.history.location.state && this.props.history.location.state.showLivelli3 && this.state.showLivelli3){
                        if(action === "PUSH"){
                            this.setState({
                                showLivelli3: false,
                                showLivelli4: true,
                            })
                        }
                        else{
                            this.setState({
                                ...this.props.history.location.state,
                                showLivelli3: false,
                                showLivelli4: true,
                                numPerPage: this.state.numPerPage,
                                pageNum: this.state.pageNum,
                                searchText: this.state.searchText,
                                livelli4: this.state.livelli4
                            })
                        }
                    }
                    else if((this.props.history.location.state && this.props.history.location.state.showLivelli1 && this.props.history.location.state.showLivelli2 &&
                        this.state.showLivelli3) || !this.props.history.location.state){
                        this.setState({
                            showLivelli1: true,
                            showLivelli2: true,
                            showLivelli3: false,
                            title: this.state.livelli1Val,
                            pageNum: this.state.pageNum,
                            numPerPage: this.state.numPerPage,
                        })
                    }
                }
                else if(this.state.showLivelli4){
                    if(action === "POP"){
                        if(this.state.livelli3HasItems){
                            this.setState({
                                showLivelli3: true,
                                showLivelli4: false,
                                title: `${this.state.livelli1Val} - ${this.state.livelli2Val}`,
                                pageNum: this.state.pageNum,
                                searchText: this.state.searchText
                            });
                        }
                        else{
                            this.setState({
                                showLivelli1: true,
                                showLivelli2: true,
                                showLivelli4: false,
                                title: this.state.livelli1Val,
                                pageNum: this.state.pageNum,
                                searchText: this.state.searchText
                            });
                        }
                    }
                    
                }            
            })
        }
        

        fetch('/api/livelli1',  {
            method: 'GET',
            headers: new Headers({
                Authorization: 'Bearer ' + sessionStorage.getItem("auth")
            })
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                livelli1: myjson
            })
        })
        .catch(error => {
            console.log(error);
        });
    }


    componentWillUnmount(){
        if(!this.props.isChild){
            this.unlisten();
        }
    }

    handleButtonClick = () => {
        
        this.setState({
            test: this.state.test + 1
        })
    }

    // handleSetStateClick = () => {
    //     this.props.history.push(this.props.location.pathname, {...this.state})
    // }

    handleLivelli1ButtonClick = (id, name) => {
        this.setState({
            livelli1Id: id,
            livelli1Val: name,
            title: name,
        }, () => {
            const form = {
                Livelli1Id: id
            };
    
            //Gets the information for level 2 and displays the level 2 dropdown
            fetch('/api/livelli2', {
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Type to be submitted. Necessary for the server to read in the data.
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the post call
                body: JSON.stringify(form)
                //Converts the response to json
            }).then(response => response.json())
            .then(myjson => {
                //Sets the information for Level 2
                this.setState({
                    livelli2: myjson,
                    showLivelli1: true,
                    showLivelli2: true,
                });
            })
            .catch(error => {
                //TODO: Set the error page
                console.log(error);
            });
        });
    }

    handleLivelli2SelectAll = (name) => {
        this.setState({
            livelli3HasItems: false,
            livelli3Id: 0,
            pageNum: 1,
        }, () => this.getLivelli4(true, false))
    
        //Sets the Level 2 dropdown text in the event the user clicks the back button
        this.setState({
            livelli2Val: name
        });
    }

    handleLivelli2Selected = (id, name) => {
        this.setState({
            livelli2Id: id,
            livelli2Val: name,
            title: `${this.state.livelli1Val} - ${name}`,
            searchText: "",
            livelli4: [], 
        }, () => {
            const form = {
                Livelli1Id: this.state.livelli1Id,
                Livelli2Id: this.state.livelli2Id,
            };
    
            //Gets the Leveli 3 information from the server
            fetch('/api/livelli3/check', {
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => response.json())
            .then(myjson => {
                if(!myjson.hasItems){
                    this.setState({
                        livelli3HasItems: false,
                        livelli3Id: 0,
                        pageNum: 1,
                    }, () => this.getLivelli4(true, false))
                }
                else{
                    this.setState({
                        livelli3HasItems: true
                    }, () => this.getLivelli3())
                }
            })
            //Displays in the event of errors in the processing of information
            .catch(error => {
                //TODO: Present error page
                console.log(error);
            });
            
            //Sets the Level 2 dropdown text in the event the user clicks the back button
            this.setState({
                livelli2Val: name
            })
        });
        //Sets up the form that will be submitted to the server to get the next set of data
        
    }

    handleLivelli3ButtonClick = (id, name) => {
        this.setState({
            livelli3Id: id,
            livelli3Val: name,
            title: `${this.state.livelli1Val} - ${this.state.livelli2Val} - ${name}`, 
            pageNum: 1,
        }, () => this.getLivelli4(true))
    }

    handleButtonChangeNumPerPage = (num) => {
        const newNumPerPage = ((this.state.numPerPage + num) > 0) && ((this.state.numPerPage + num) <= this.state.livelli4TotalArticoli) ? (this.state.numPerPage + num) : this.state.numPerPage;
       
        if(newNumPerPage !== this.state.numPerPage){
            this.setState({
                numPerPage: newNumPerPage,
            }, () => this.getLivelli4(false, true));
        }
        else if(this.state.numPerPage > this.state.livelli4TotalArticoli){
            if(num < 0){
                this.setState({
                    numPerPage: this.state.numPerPage + num
                });
            }
            
        }
    }

    handleInputChangeNumPerPage = (e) => {
        e.preventDefault(e);

        const isNum = /^\d+$/.test(e.target.value);

        if(isNum){
            this.setState({
                numPerPage: parseInt(e.target.value, 10)  
            });
        }
        else if(e.target.value === ''){
            this.setState({
                numPerPage: e.target.value
            })
        }
    }

    handleNumPerPageSubmit = (e) => {
        e.preventDefault();

        if(this.state.numPerPage >= this.state.livelli4TotalArticoli){
            this.setState({
                pageNum: 1,
                numPerPage: this.state.livelli4TotalArticoli
            }, () => this.getLivelli4(false, true))
        }
        else{
            this.setState({
                pageNum: 1,
            }, () => this.getLivelli4(false, true))
        }
    }

    handleSearchChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();
    
        this.getLivelli4(true, true);
    } 

    handlePrev = (e) => {
        this.setState({
            pageNum: this.state.pageNum - 1
        }, () => this.getLivelli4());
    }

    handleNext = (e) => {
        this.setState({
            pageNum: this.state.pageNum + 1
        }, () => this.getLivelli4());
    }

    getLivelli3 = () => {
        const form = {
            Livelli1Id: this.state.livelli1Id,
            Livelli2Id: this.state.livelli2Id,
        };

        //Gets the Leveli 3 information from the server
        fetch('/api/livelli3', {
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            if(myjson.error){
                //TODO: Create error page
            }
            else{
                //Sets the state so that the Level 3 buttons are displayed
                if(!this.props.isChild){
                    this.setState({
                        livelli3: myjson,
                    }, () => this.props.history.push(this.props.history.location.pathname, {...this.state}));
                }
                else{
                    this.setState({
                        livelli3: myjson,
                        showLivelli1: false,
                        showLivelli2: false,
                        showLivelli3: true,
                        showLivelli4: false,
                    })
                }
                
                
                
            }
            
        })
        //Displays in the event of errors in the processing of information
        .catch(error => {
            
            //TODO: Present error page
            console.log(error); 
        });
    }
    getLivelli4 = (isNew, noSave) => {
        let apiURL = `/api/livelli4`
        let form = {}
        if(this.state.searchText !== ""){
            apiURL = `${apiURL}/search`
            form = {
                Livelli1Id: this.state.livelli1Id,
                Livelli2Id: this.state.livelli2Id,
                Livelli3Id: this.state.livelli3Id,
                NumPerPage: isNew ? 5 : this.state.numPerPage,
                PageNum: this.state.pageNum,
                SearchText: this.state.searchText
            };
        }
        else{
            form = {
                Livelli1Id: this.state.livelli1Id,
                Livelli2Id: this.state.livelli2Id,
                Livelli3Id: this.state.livelli3Id,
                NumPerPage: isNew ? 5 : this.state.numPerPage,
                PageNum: this.state.pageNum,
            };
        }
        

        fetch(apiURL, {
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            //Sets the state so that the Level 3 buttons are displayed           
            if(myjson.error === "Empty"){     
                if(!this.props.isChild){
                    this.setState({
                        numPerPage: this.state.numPerPage,
                        currentPage: 1,
                        livelli4TotalArticoli: 0,
                        livelli4TotalPages: 1,
                        livelli4: [],
                    }, () => {
                        if(!this.state.showLivelli4 && !noSave){
                            console.log(`Empty: Pushing ${this.state}`)
                            this.props.history.push(this.props.history.location.pathname, {...this.state})
                        }
                    })
                }
                else{
                    this.setState({
                        numPerPage: this.state.numPerPage,
                        currentPage: 1,
                        livelli4TotalArticoli: 0,
                        livelli4TotalPages: 1,
                        livelli4: [],
                        showLivelli1: false,
                        showLivelli2: false,
                        showLivelli3: false,
                        showLivelli4: true,
                    })
                }
                
            }
            else{
                if(!this.props.isChild){
                    this.setState({
                        livelli4TotalArticoli: myjson.totalArticoli,
                        livelli4TotalPages: myjson.totalPages,
                        livelli4: myjson.data,
                        numPerPage: isNew ? 5 : this.state.numPerPage
                    }, () => {
                        const numCheck = this.state.numPerPage < this.state.livelli4TotalArticoli ? this.state.numPerPage : this.state.livelli4TotalArticoli;
                        this.setState({
                            numPerPage: numCheck
                        }, () => {
                            if(!this.state.showLivelli4 && !noSave){
                                console.log(`Pushing ${this.state}`)
                                this.props.history.push(this.props.history.location.pathname, {...this.state})
                            }
                        });
                    })
                }
                else{
                    this.setState({
                        livelli4TotalArticoli: myjson.totalArticoli,
                        livelli4TotalPages: myjson.totalPages,
                        livelli4: myjson.data,
                        numPerPage: isNew ? 5 : this.state.numPerPage,
                        showLivelli1: false,
                        showLivelli2: false,
                        showLivelli3: false,
                        showLivelli4: true,
                    }, () => {
                        const numCheck = this.state.numPerPage < this.state.livelli4TotalArticoli ? this.state.numPerPage : this.state.livelli4TotalArticoli;
                        this.setState({
                            numPerPage: numCheck
                        });
                    })
                }
            }
        })
        //Displays in the event of errors in the processing of information
        .catch(error => {
            //Catches no items returned
            if(error.name === 'SyntaxError'){
                //TODO: Create page for no entries
                console.log(error);
            }
            else{
                //TODO: Present error page
                console.log(error);
            }          
        });
    }

    handleGoBack = () => {
        if(this.state.showLivelli3){
            this.setState({
                showLivelli1: true,
                showLivelli2: true,
                showLivelli3: false,
                title: this.state.livelli1Val,
                livelli2Val: "Scegli il Livello 2"
            })
        }
        if(this.state.showLivelli4){
            if(this.state.livelli3HasItems){
                this.setState({
                    showLivelli3: true,
                    showLivelli4: false,
                    title: `${this.state.livelli1Val} - ${this.state.livelli2Val}`
                })
            }
            else{
                this.setState({
                    showLivelli1: true,
                    showLivelli2: true,
                    showLivelli4: false,
                    title: this.state.livelli1Val,
                    livelli2Val: "Scegli il Livello 2"
                })
            }
        }
    }
    /**
     * Renders the page
     */
    render() {
        const titolo = (
            <Container className="d-flex align-items-center justify-content-center" style={{paddingBottom: "15px"}} fluid>
                {this.state.showLivelli4 ? 
                    <Row className="d-flex" style={{margin: "0px", width: "100%"}}>
                        <Col xs={{size: 12, order: 2}} md={{size: 3, order: 1}} className="d-flex align-items-center justify-content-md-start justify-content-center pl-md-0 mb-2 mb-md-0" >
                            <Form className="form" onSubmit={this.handleNumPerPageSubmit}>
                                <Row className="d-flex align-items-center" >  
                                    <Col className=" d-flex justify-content-end col-4" style={{padding: "0px", marginRight: "0px", height: "40px"}}>
                                        <Button onClick={() => this.handleButtonChangeNumPerPage(-1)} style={{height: "100%", width: "100%", padding: "0px", borderTopLeftRadius : "25px", borderWidth: "medium", borderBottomLeftRadius : "25px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderRight: "0px", fontSize: "25px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>-</Button>
                                    </Col>
                                    <Col className="d-flex justify-content-center col-4" style={{padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px"}}>
                                        {this.state.livelli4TotalArticoli === 0 ? 
                                            <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> :
                                            <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/>}
                                    </Col>
                                    <Col className=" d-flex justify-content-start col-4" style={{padding: "0px", marginRight: "0px", height: "40px"}}>
                                        <Button onClick={() => this.handleButtonChangeNumPerPage(1)} style={{height: "100%", width: "100%", padding: "0px", borderWidth: "medium", borderTopRightRadius : "25px", borderBottomRightRadius : "25px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderLeft: "0px", fontSize: "25px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>+</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                        <Col xs={{size: 12, order: 1}} md={{size: 6, order: 2}} className="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                            <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>{this.state.title}</h4>
                        </Col>
                        <Col xs={{size: 12, order: 3}} md={{size: 3, order: 3}} className="d-flex align-items-center justify-content-md-end justify-content-center pr-md-0" >    
                                <Search text={this.state.searchText} handleSearchChange={this.handleSearchChange} handleSearchSubmit={this.handleSearchSubmit} />
                        </Col>
                    </Row> :
                    <Container className="d-flex align-items-center justify-content-center">
                        <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>{this.state.title}</h4>
                    </Container>
                }
                
            </Container>
        );

        const navFooter = (
            <Container className="d-flex align-items-center justify-content-center" style={{padding: "0px", paddingBottom: "15px"}} fluid>
                <Row style={{margin: "0px", width: "100%"}}>
                    <Col className="d-flex align-items-center justify-content-start col-6" style={{paddingLeft: "0px", color: "#011e41"}}>
                        {this.state.livelli4TotalArticoli !== 0 ? "Mostra da " + ((this.state.numPerPage*(this.state.pageNum-1))+1) + " a " + (this.state.numPerPage*this.state.pageNum < this.state.livelli4TotalArticoli ? this.state.numPerPage*this.state.pageNum : this.state.livelli4TotalArticoli) + " di " + this.state.livelli4TotalArticoli + " risultati" : null}
                    </Col>
                    <Col className="d-flex align-items-center justify-content-end col-6" style={{paddingLeft: "0px", color: "#011e41"}}>
                        {this.state.pageNum === 1 ? null : <a style={{paddingRight: "10px", cursor: "pointer"}} onClick={this.handlePrev}>Indietro</a> }
                        {(this.state.pageNum === 1 && this.state.pageNum === this.state.livelli4TotalPages) || this.state.livelli4TotalArticoli === 0 ? null : this.state.pageNum}
                        {(this.state.pageNum === this.state.livelli4TotalPages) || this.state.livelli4TotalArticoli === 0 ? <p style={{paddingLeft: "35px"}}></p> : <a style={{paddingLeft: "10px", cursor: "pointer"}} onClick={this.handleNext}>Avanti</a>}
                    </Col>
                </Row>
            </Container>
        );

        return (
            <Container fluid style={{color: "#011e41"}}> 
                {titolo}
                {this.state.showLivelli1 || this.state.showLivelli2 ?
                    <Listino 
                        showLivelli1 = {this.state.showLivelli1}
                        livelli1={this.state.livelli1}
                        livelli1Id = {this.state.livelli1Id}
                        handleLivelli1ButtonClick = {this.handleLivelli1ButtonClick}
                        showLivelli2 = {this.state.showLivelli2}
                        livelli2 = {this.state.livelli2}
                        livelli2Id = {this.state.livelli2Id}
                        livelli2Val = {this.state.livelli2Val}
                        handleLivelli2Selected = {this.handleLivelli2Selected}
                        handleLivelli2SelectAll = {this.handleLivelli2SelectAll}
                    /> : null}
                {this.state.showLivelli3 ?
                    <div>
                        <Listino2
                            showLivelli3 = {this.state.showLivelli3}
                            livelli3 = {this.state.livelli3}
                            livelli3Id = {this.state.livelli3Id}
                            handleLivelli3ButtonClick = {this.handleLivelli3ButtonClick}
                        />
                    </div> : null} 
                {this.state.showLivelli4 ?
                <div>
                    <Listino3
                        showLivelli4={this.state.showLivelli4}
                        livelli4={this.state.livelli4}
                        handleCodiceArticoloClick={this.props.handleCodiceArticoloClick}
                        nuovoOrdine={this.props.isChild}
                    />
                    {navFooter} 
                </div> : null}
                {(this.state.showLivelli3 || this.state.showLivelli4) ?
                    <Container fluid>
                        <Row style={{margin: "0px", width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-start col-4" style={{paddingLeft: "0px", color: "#011e41"}}>
                                <Button className="text-center" style={{width: '50%', marginTop: '5vh', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleGoBack}>
                                    <i className="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;Vai indietro
                                </Button>
                            </Col>
                        </Row>
                    </Container> : null
                }
            </Container>
        )
    }
}

export default withRouter(ListinoContainer)


// WEBPACK FOOTER //
// ./src/containers/ListinoContainer.js